import { doRequest } from '@r1-frontend/do-request';
import { equipment } from '@r1-frontend/api-domru/full-buy/v1/equipment';
import { IEquipment } from '@r1-frontend/api-domru/full-buy/v1/equipment/dto/Equipment.dto';

import { EShopCategory } from '~/src/api/content/shop/getShopItems';
import { setLoadingStatus, setRouters } from '~/src/features/internetV2/store/actions';
import { sortFunction } from '~/src/helpers/functions';
import { TDispatch, TGetState } from '~/src/store';

const getRouters = () => {
    return async(dispatch: TDispatch, getState: TGetState): Promise<void> => {
        dispatch(setLoadingStatus(true));

        const {
            city: { provider: { providerId } },
        } = getState();

        const response = await doRequest.fullBuy<IEquipment[]>(
            equipment({
                categories: [EShopCategory.Routers],
                providerId,
            }),
        );

        if (response.isSuccess) {
            const routers = response.payload
                .sort(sortFunction)
                .map(item => ({ ...item, alias: item.alias?.replace(new RegExp('-im$'), '') }));

            dispatch(setRouters(routers));
        } else {
            dispatch(setRouters([]));
        }
        dispatch(setLoadingStatus(false));
    };
};

export default getRouters;
